/* eslint-disable no-restricted-globals */

'use strict';

const constructorIOPLP = require('org/constructorio/constructorIOPLP');
const { getConstructorIOSettings } = require('org/constructorio/clientWrapper');
const { getConstructorioSearch } = require('org/constructorio/request');
const util = require('org/util');
var searchModuleBase = require('org/search/search');

/**
 * Disable unselected By Teams refinement values on PLP page.
 * @param {Object} teamRefinement - team refinement to work on
 * @param {Object} selectedTeam - selected team
 * @param {Object} $this - the scope of execution
 *
 * @returns {boolean} if operation success of not
 */
function disableTeamRefinements(teamRefinement, selectedTeam, $this) {
    if (selectedTeam.length === 1) {
        teamRefinement.find('li a:not(.m-selected)').each(function () {
            $(this).addClass('disabled-team');
        });
    } else {
        // avoid the 2nd selection of team refinement during the page reload
        $this.removeClass('m-selected');
        teamRefinement.find('li a:not(.m-selected)').each(function () {
            $(this).addClass('disabled-team');
        });
        return false;
    }
    return true;
}

/**
 * Append selected size to the existing url
 * @param {string} baseUrl - base url to append to
 *
 * @returns {string} Updated url
 */
function getSelectedModelSizeUrl(baseUrl) {
    if ($('.js-select-model-size:visible').length > 0) {
        var selectedSize = $('.js-select-model-size:visible').val();
        $('body').find('.js-select-model-size:hidden').val(selectedSize).trigger('change', [true]);
        if (selectedSize) {
            var urlParams = {
                viewPreference: selectedSize
            };
            return util.appendParamsToUrl(baseUrl, urlParams);
        }
    }
    return baseUrl;
}

/**
 * Update the url with selected sorting rule
 * @param {string} baseUrl - base url to modify
 *
 * @returns {string} Updated url
 */
function getSelectedSortingRule(baseUrl) {
    if ($('select.b-sort-select').find('option:selected').length > 0) {
        var selectedsortingRule = $('select.b-sort-select').find('option:selected').data('id');
        if ($(window).width() < 1024) {
            selectedsortingRule = $('input[name="sortMobileOption"]:checked').val();
        }

        if (selectedsortingRule) {
            var urlParams = {
                srule: selectedsortingRule
            };
            // remove from srule from url if present then add srule with latest updated values
            if (baseUrl.indexOf('srule=') !== -1) {
                baseUrl = util.removeParamFromURL(baseUrl, 'srule'); // eslint-disable-line no-param-reassign
            }
            return util.appendParamsToUrl(baseUrl, urlParams);
        }
    }
    return baseUrl;
}

/**
 * Checks if the current page is a search page by checking the presence of '?q=' in the URL.
 *
 * @returns {number} -1 if '?q=' is not found in the URL (indicating that the page is not a search page), otherwise returns the index at which '?q=' starts in the URL.
 */
const isSearchPage = () => {
    return window.location.href.indexOf('?q=') > -1 ? window.location.href.indexOf('?q=') : window.location.href.indexOf('&q=');
};

/**
 * Initialize window event listener for onpopstate to reload page with the updated url.
 */
searchModuleBase.postInit = () => {
    // Function to handle the popstate event
    window.onpopstate = function () {
        location.reload();
    };
};

searchModuleBase.applyFilter = () => {
    // Handle refinement value selection and reset click
    $('.js-page').on('click change', '.js-select-model-size, .js-plp-sidebar li a:not(".b-refinements_category-link"), .js-category-link, .js-plp-sidebar .js-refinements_clear, .js-refinement_swatch, .js-selected-refinements a',
        (e, isTriggered) => {
            e.preventDefault();
            e.stopPropagation();
            const $currentTarget = $(e.currentTarget);

            if (e.type === 'click' && $currentTarget.hasClass('js-select-model-size')) {
                return false;
            }

            if (isTriggered && $currentTarget.hasClass('js-select-model-size')) {
                return false;
            }

            // Disable unselected team refinement values on PLP page
            const teamRefinement = $('.b-refinements-item[data-refinement-id="team"]:visible');
            const selectedTeam = teamRefinement ? teamRefinement.find('li a.m-selected') : '';
            if (isSearchPage() === -1 && teamRefinement && selectedTeam.length > 0) {
                const updateRefinement = disableTeamRefinements(teamRefinement, selectedTeam, $currentTarget);
                if (!updateRefinement) {
                    return false;
                }
            }

            searchModuleBase.methods.resetLoading();
            let newUrl = $currentTarget.data('href');

            if (newUrl === undefined) {
                const $canonicalUrl = $('.js-canonical-url');
                if ($canonicalUrl.attr('data-action-sizeModelUrl') !== null && $canonicalUrl.attr('data-queryString') !== null) {
                    newUrl = $canonicalUrl.attr('data-action-sizeModelUrl') + '?' + $canonicalUrl.attr('data-queryString');
                }
            }

            newUrl = getSelectedModelSizeUrl(newUrl);

            if ($(window).width() < 1024) {
                const currentUrl = window.location.href;
                if (currentUrl.indexOf('isShopAllUrl') > -1) {
                    const urlParams = {
                        isShopAllUrl: true
                    };
                    newUrl = util.appendParamsToUrl(newUrl, urlParams);
                }
            }

            // Added selected sorting rules in refinement url if sorting option is in present url
            if (window.location.href.indexOf('srule=') !== -1) {
                newUrl = getSelectedSortingRule(newUrl);
            }

            // get the  opened refinement items
            let showFilters = [];
            let filters = '';
            if ($('.b-refinements-content.show').length) {
                $('.b-refinements-content.show').each(function () {
                    const filter = $(this).attr('data-refinementattr');
                    showFilters.push(filter);
                });
            }

            filters = showFilters.join(',');

            if (!$currentTarget.hasClass('m-disabled')) {
                $currentTarget.trigger('search:filter', e);
                const $gridFooter = $('.js-grid_footer');

                const data = {
                    page: $gridFooter.data('page-number'),
                    selectedUrl: newUrl,
                    selectedFilter: filters
                };

                const cIOSettings = getConstructorIOSettings();

                history.pushState({ type: 267 }, null, window.location.href);

                if ((cIOSettings.search_enabled || cIOSettings.browse_enabled) && window.searchParams) {
                    getConstructorioSearch({ url: newUrl, data })
                        .then((res) => {
                            const a = constructorIOPLP.convertCIOToHTMLString(res, 'searchResultsNoDecorator');
                            return a;
                        })
                        .catch(() => {
                            searchModuleBase.methods.constractorRequestErrorHandler();
                        })
                        .then((response) => {
                            if (!response) {
                                return;
                            }
                            searchModuleBase.methods.applyFilterSuccessHandler(response, $currentTarget);
                        });
                } else {
                    searchModuleBase.methods.applyFilterRequest(newUrl, data, $currentTarget);
                }
            }
            return true;
        });
};

module.exports = searchModuleBase;
